import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { Box, Grow, IconButton, InputAdornment, Tooltip } from '@mui/material';
import {
  GridToolbar,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';
import { useState } from 'react';
import MultipleSelect from './MultipleSelect';

const ServiceManagementDatagridToolbar = (props) => {
  const { list, setList } = props;

  const [showToolbar, setShowToolbar] = useState(false);

  return (
    <GridToolbarContainer
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 1,
        background: 'inherit',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <GridToolbarQuickFilter
          size="small"
          sx={{
            '& .MuiGridToolbarQuickFilter-root': {
              borderRadius: '5px',
              border: '1px solid blue !important',
            },
            '& .MuiInputBase-root': {
              borderRadius: '5px',
            },
            '& .MuiFilledInput-root': {
              borderRadius: '5px',
            },
            '& .MuiInput-underline:before, & .MuiInput-underline:after': {
              display: 'none',
            },
            '& .MuiInputLabel-root': {
              color: 'gray',
            },
          }}
          variant="standard"
          InputProps={{
            placeholder: 'Søg...',
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ color: 'gray' }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Grow in={showToolbar}>
          <GridToolbar />
        </Grow>

        <Tooltip
          title={showToolbar ? 'Skjul instillinger' : 'Vis instillinger'}
          placement="top"
        >
          <IconButton
            onClick={() => setShowToolbar(!showToolbar)}
            sx={{ borderRadius: 1 }}
          >
            {showToolbar ? <FilterListOffIcon /> : <FilterListIcon />}
          </IconButton>
        </Tooltip>
        <MultipleSelect list={list} setList={setList} />
      </Box>
    </GridToolbarContainer>
  );
};

export default ServiceManagementDatagridToolbar;
